module.exports = __webpack_public_path__ + "static/media/HawksoftIcon.47150595.svg";